<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button type="primary" icon="el-icon-search" @click="selectItem()">
                    검색
                </el-button>
            </div>
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px" label-position="right">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="제조사">
                                <el-select v-model="form.maker">
                                    <el-option
                                        v-for="item in makerList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="제품군">
                                <el-select v-model="form.modelGroup" @change="onModelGroupChange" style="width: 50%;">
                                    <el-option
                                        v-for="item in modelGroupList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                        </el-option>
                                    </el-select>
                                    <el-select v-model="form.subModelGroup" :disabled="!form.modelGroup" style="width: 50%;">
                                        <el-option
                                        v-for="item in subModelGroupList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="구분">
                                <el-input type="text" v-model="form.description" @keyup.native.enter="selectItem"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="모델">
                                <el-input type="text" v-model.trim="form.useModelNm" @keyup.native.enter="selectItem"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="품번">
                                <el-input type="text" v-model.trim="form.itemCd" @keyup.native.enter="selectItem"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="품명">
                                <el-input v-model="form.itemNm" @keyup.native.enter="selectItem"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="grid-wrap">
                <div class="table-area">
                    <div class="btn-type1">
                        <el-button type="primary" icon="el-icon-document-add" @click="saveItem">
                            저장
                        </el-button>
                    </div>
                    <div class="table-b">
                        <ag-grid-vue 
                        style="width: 100%; height: 330px;"
                        class="ag-theme-alpine"    
                        :enableRangeSelection="true"
                        :framework-components="frameworkComponents"
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady"/>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * Modal index mixin
 */
import mixin from './index';

/**
 * * AG-Grid components
 */
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

// 숫자에 콤마표시
function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
    mixins: [mixin],
    components: {Layout},
    data() {
        return {
            title: '구매자재선택',
            form: {
                maker: '',
                modelGroup: '',
                subModelGroup: '',
                gb: '',
                prodNo: '',
                useModelNm: '',
                modelNm: '',
                itemCd: '',
                itemNm: ''
            },
            makerList: [{ key: '', value: '전체' },{key: '01', value: '서울지점'}, {key: '02', value: '경기'}],
            modelGroupList: [{ key: '', value: '전체' }, { key: '01', value: '컴퓨터' }, { key: '02', value: '모니터' }],
            subModelGroupList: [{ key: '', value: '전체' }, { key: '01', value: '데스크탑' }, { key: '02', value: '노트북' }],
            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponents : {
                checkbox: CheckboxCellRenderer,
            },
            columnDefs:[
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellRenderer: 'checkbox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'No', 
                    field:'no', 
                    width:80,
                    cellStyle : {textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'대표모델', 
                    field:'useModelNm',  
                    width:130,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'모델', 
                    field:'modelNm',  
                    width:130,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'구분', 
                    field:'description', 
                    width:100,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '품번', 
                    field:'itemCd', 
                    width: 200,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName: '품명', 
                    field:'itemNm', 
                    width: 260,
                    cellStyle:{textAlign:'left'},
                },
                {
                    headerName: '소비자가', 
                    field:'unitPrice3',
                    width: 120,
                    cellStyle:{textAlign:'right'},
                },
                {
                    headerName: '재고수량', 
                    field:'goodQty', 
                    width: 120,
                    cellStyle:{textAlign:'right'},
                },
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            // AG-GRID OPTION [END]
        }
    },
    created() {
        this.form = this.data;
    },
    mounted() {
        //pop slots modal move
        $(".animation-content").addClass('pop_min2');
        $(".animation-content").draggable({'cancel':'.modal-card-body'});
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        handleNodeClick(data) {
            console.log(data);
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.saveItem([params.data]);
        },
        onCellClicked(params) {
            const field = params.colDef.field;
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 제조사
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
                    .then(response => {
                        this.makerList = response.data || []
                        this.makerList.unshift({key:'', value:'전체'})
                    });

                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupNmList = response.data || []
                        this.modelGroupNmList.unshift({key:'', value:'전체'})
                    });
                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupList = response.data || []
                        this.modelGroupList.unshift({key:'', value:'전체'})
                        console.log('response.data :', response.data )
                    });
            } else {
                if(param.parentId === ''){
                    this.subModelGroupShow =  false
                } else{
                    this.subModelGroupShow =  true

                    // 하위 제품군 : ModelGroup, CAT_LVL(2)
                    this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.subModelGroupList = response.data || [];
                            this.subModelGroupList.unshift({key:'', value:'전체'});

                            this.form.subModelGroup = '';
                        });
                }
                
            } 
        },
        onModelGroupChange(val){
            // console.log('onModelGroupChange start====', val)
            // 모델이 변경시 하위 제품군 조회
            this.getCombo({flag: '', parentId: val})
        },
        selectItem(e){
            /** 검색 */

            const vform = {
                    companyId: this.$store.state.loginInfo.compCd || '',
                    maker: this.form.maker || '',
                    itemGroup: this.form.subModelGroup && this.form.subModelGroup != '' ? this.form.subModelGroup : this.form.modelGroup || '', // 제품군
                    modelGroup : this.form.subModelGroup && this.form.subModelGroup != '' ? this.form.subModelGroup : this.form.modelGroup || '', // 제품군
                    description: this.form.description || '',
                    useModelNm: this.form.useModelNm || '',
                    modelNm : this.form.useModelNm || '',                     // 모델명
                    itemCd: this.form.itemCd || '',
                    itemNm: this.form.itemNm || '',
                    asAgentId: '3', //this.$store.state.loginInfo.asAgentId TODO:추후 STORE에서 읽어들이도록 수정할것
                    sortType: '',
                    page: 1,
                    totalPage: 9999,
                    totalCount: 9999,
                    curPage: 0,
                    processTime: '',
                    userId: this.$store.state.loginInfo.id
                }
             
            //모델 inputBox에 text 기입시 분기 처리 되어있음(as-is)
            let postUrl;
            if (this.form.useModelNm === '') postUrl = "/api/workMng/mateEntering/popup/list";
            else postUrl = "/api/workMng/reqMateEnter/popup/list";
    
            this.$store.commit('loading');
            // console.log('selectItem vform : ', vform) 
            this.$http.post((postUrl), vform, {timeout: 60000*20} 
                ).then(response => {
                console.log('selectItem :' , response.data);

                this.rowData = response.data.map(x=>{
                    x.unitPrice3 = comma(x.unitPrice3);
                    if(x.goodQty == null) x.goodQty = 0;
                    x.goodQty = comma(x.goodQty);
                    x.useModelNm = x.standardModelNm ? x.standardModelNm || '' : x.useModelNm || '';
                    
                    return x;
                })
            }).finally(() => {
                this.$store.commit('finish');
            });
        },
        saveItem(param){
            /** 저장 */
            let list = this.rowData.filter(v => v.chk==='Y');
            
            // if(param && param.length === 1) {
            //     list = param;
            // }
            
            if(list.length == 0){
                this.$swal({
                    type: 'warning',
                    text: '자재를 선택해 주십시요.'
                });

                return false
            }

            this.$emit('close', list);

        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>